"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
var VerifyAccountContext = React.createContext({});
exports.VerifyAccountConsumer = VerifyAccountContext.Consumer;
exports.VerifyAccountProvider = function (_a) {
    var action = _a.action, blockChannelSwitch = _a.blockChannelSwitch, channel = _a.channel, children = _a.children;
    var _b = __read(React.useState(false), 2), accountBlocked = _b[0], setAccountBlocked = _b[1];
    return (React.createElement(VerifyAccountContext.Provider, { value: {
            accountBlocked: accountBlocked,
            action: action,
            blockChannelSwitch: blockChannelSwitch,
            channel: channel,
            setAccountBlocked: setAccountBlocked
        } }, children));
};
exports["default"] = VerifyAccountContext;
